/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerContractDto } from './BorrowerContractDto';
import {
    BorrowerContractDtoFromJSON,
    BorrowerContractDtoFromJSONTyped,
    BorrowerContractDtoToJSON,
    BorrowerContractDtoToJSONTyped,
} from './BorrowerContractDto';
import type { BorrowerOtherFileDto } from './BorrowerOtherFileDto';
import {
    BorrowerOtherFileDtoFromJSON,
    BorrowerOtherFileDtoFromJSONTyped,
    BorrowerOtherFileDtoToJSON,
    BorrowerOtherFileDtoToJSONTyped,
} from './BorrowerOtherFileDto';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';
import type { BorrowerContractLoanDetailDto } from './BorrowerContractLoanDetailDto';
import {
    BorrowerContractLoanDetailDtoFromJSON,
    BorrowerContractLoanDetailDtoFromJSONTyped,
    BorrowerContractLoanDetailDtoToJSON,
    BorrowerContractLoanDetailDtoToJSONTyped,
} from './BorrowerContractLoanDetailDto';
import type { BorrowerContractSpecialConditionsDto } from './BorrowerContractSpecialConditionsDto';
import {
    BorrowerContractSpecialConditionsDtoFromJSON,
    BorrowerContractSpecialConditionsDtoFromJSONTyped,
    BorrowerContractSpecialConditionsDtoToJSON,
    BorrowerContractSpecialConditionsDtoToJSONTyped,
} from './BorrowerContractSpecialConditionsDto';
import type { BorrowerSubscriberDto } from './BorrowerSubscriberDto';
import {
    BorrowerSubscriberDtoFromJSON,
    BorrowerSubscriberDtoFromJSONTyped,
    BorrowerSubscriberDtoToJSON,
    BorrowerSubscriberDtoToJSONTyped,
} from './BorrowerSubscriberDto';

/**
 * Full details of a borrower contract
 * @export
 * @interface GetBorrowerContractDetailsResponse
 */
export interface GetBorrowerContractDetailsResponse {
    /**
     * 
     * @type {BorrowerContractDto}
     * @memberof GetBorrowerContractDetailsResponse
     */
    contract?: BorrowerContractDto;
    /**
     * 
     * @type {BorrowerSubscriberDto}
     * @memberof GetBorrowerContractDetailsResponse
     */
    subscriber?: BorrowerSubscriberDto;
    /**
     * Survey answers of the borrower (only present if includeQuestionnaire is true)
     * @type {Array<QuestionAnswerDto>}
     * @memberof GetBorrowerContractDetailsResponse
     */
    surveyAnswers?: Array<QuestionAnswerDto> | null;
    /**
     * List of loans with their guarantees and pricing
     * @type {Array<BorrowerContractLoanDetailDto>}
     * @memberof GetBorrowerContractDetailsResponse
     */
    loans?: Array<BorrowerContractLoanDetailDto>;
    /**
     * 
     * @type {BorrowerContractSpecialConditionsDto}
     * @memberof GetBorrowerContractDetailsResponse
     */
    specialConditions?: BorrowerContractSpecialConditionsDto;
    /**
     * Files of the other borrowers attached to the same loan project (co-borrowers)
     * @type {Array<BorrowerOtherFileDto>}
     * @memberof GetBorrowerContractDetailsResponse
     */
    otherBorrowerFiles?: Array<BorrowerOtherFileDto>;
}

/**
 * Check if a given object implements the GetBorrowerContractDetailsResponse interface.
 */
export function instanceOfGetBorrowerContractDetailsResponse(value: object): value is GetBorrowerContractDetailsResponse {
    return true;
}

export function GetBorrowerContractDetailsResponseFromJSON(json: any): GetBorrowerContractDetailsResponse {
    return GetBorrowerContractDetailsResponseFromJSONTyped(json, false);
}

export function GetBorrowerContractDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBorrowerContractDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contract': json['contract'] == null ? undefined : BorrowerContractDtoFromJSON(json['contract']),
        'subscriber': json['subscriber'] == null ? undefined : BorrowerSubscriberDtoFromJSON(json['subscriber']),
        'surveyAnswers': json['surveyAnswers'] == null ? undefined : ((json['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
        'loans': json['loans'] == null ? undefined : ((json['loans'] as Array<any>).map(BorrowerContractLoanDetailDtoFromJSON)),
        'specialConditions': json['specialConditions'] == null ? undefined : BorrowerContractSpecialConditionsDtoFromJSON(json['specialConditions']),
        'otherBorrowerFiles': json['otherBorrowerFiles'] == null ? undefined : ((json['otherBorrowerFiles'] as Array<any>).map(BorrowerOtherFileDtoFromJSON)),
    };
}

export function GetBorrowerContractDetailsResponseToJSON(json: any): GetBorrowerContractDetailsResponse {
    return GetBorrowerContractDetailsResponseToJSONTyped(json, false);
}

export function GetBorrowerContractDetailsResponseToJSONTyped(value?: GetBorrowerContractDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contract': BorrowerContractDtoToJSON(value['contract']),
        'subscriber': BorrowerSubscriberDtoToJSON(value['subscriber']),
        'surveyAnswers': value['surveyAnswers'] == null ? undefined : ((value['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
        'loans': value['loans'] == null ? undefined : ((value['loans'] as Array<any>).map(BorrowerContractLoanDetailDtoToJSON)),
        'specialConditions': BorrowerContractSpecialConditionsDtoToJSON(value['specialConditions']),
        'otherBorrowerFiles': value['otherBorrowerFiles'] == null ? undefined : ((value['otherBorrowerFiles'] as Array<any>).map(BorrowerOtherFileDtoToJSON)),
    };
}

